import { Button, ButtonProps } from '@compass/Button'
import { copyToClipboard } from 'helpers/clipboard'
import { Clipboard, ClipboardCheck } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'

export function CopyButton({
  copyValue,
  onCopy,
  onError,
  ...props
}: { copyValue: string; onCopy?: () => void; onError?: () => void } & ButtonProps) {
  const [isCopied, setIsCopied] = useState(false)

  const onPress = useCallback(async () => {
    try {
      await copyToClipboard(copyValue)
      setIsCopied(true)
      onCopy?.()
    } catch {
      onError?.()
    }
  }, [copyValue, onCopy, onError])

  useEffect(() => {
    if (!isCopied) {
      return
    }

    const timer = setTimeout(() => setIsCopied(false), 1000)
    return () => clearTimeout(timer)
  }, [isCopied])

  return (
    <Button variant='secondary' size='sm' isIcon aria-label='Copy value' onPress={onPress} {...props}>
      <span className='relative flex items-center justify-center'>
        <Clipboard
          className={`absolute motion-reduce:transition-none transition-all ${isCopied ? 'opacity-0 -translate-y-2' : 'opacity-100'}`}
        />
        <ClipboardCheck
          className={`absolute motion-reduce:transition-none transition-all ${isCopied ? 'opacity-100' : 'opacity-0 translate-y-2'}`}
        />
      </span>
    </Button>
  )
}
